import { useNavigate } from "react-router-dom";
import { FileCode } from "lucide-react";
import { getCategoryImage } from "@/lib/categoryImages";
import { getCategoryGradient } from "@/lib/categoryGradients";

interface RecommendedMacro {
  id: string;
  slug: string;
  name: string;
  installs_count: number;
  screenshot_url: string | null;
  category?: string | null;
  public_profiles: {
    username: string;
    full_name: string | null;
  };
}

interface RecommendedMacroCardProps {
  macro: RecommendedMacro;
}


export const RecommendedMacroCard = ({ macro }: RecommendedMacroCardProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/m/${macro.slug}`);
  };

  return (
    <div
      onClick={handleClick}
      className="flex gap-4 p-4 rounded-lg transition-all group cursor-pointer"
    >
      {/* Left: Thumbnail/Icon */}
      <div className={`flex-shrink-0 w-[140px] h-[78px] rounded-lg flex items-center justify-center overflow-hidden transition-transform group-hover:scale-105 ${
        macro.screenshot_url 
          ? "bg-muted" 
          : getCategoryImage(macro.category)
            ? getCategoryGradient(macro.category)
            : "bg-muted"
      }`}>
        {macro.screenshot_url ? (
          <img
            src={macro.screenshot_url}
            alt={macro.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : getCategoryImage(macro.category) ? (
          <img
            src={getCategoryImage(macro.category)!}
            alt={macro.category || "Category"}
            className="w-16 h-16 object-contain rounded-lg"
            loading="lazy"
          />
        ) : (
          <FileCode className="w-7 h-7 text-muted-foreground" />
        )}
      </div>

      {/* Right: Text content */}
      <div className="flex-1 min-w-0 flex flex-col justify-center">
        <h4 className="text-sm font-medium line-clamp-2 leading-tight mb-0.5 transition-transform group-hover:scale-105 origin-left">
          {macro.name}
        </h4>
        <p className="text-xs text-muted-foreground transition-transform group-hover:scale-105 origin-left">
          {macro.public_profiles?.full_name || macro.public_profiles?.username || "Unknown User"}
        </p>
        <p className="text-xs text-muted-foreground transition-transform group-hover:scale-105 origin-left">
          {macro.installs_count.toLocaleString()} uses
        </p>
      </div>
    </div>
  );
};
